import { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Stack, Alert, Typography,
} from "@mui/material";
import { Receptor, saveReceptor } from "../services/billing";
import ReceptorFields, {
  ReceptorFormValue, receptorFormFrom, receptorPayload, receptorEmailsInvalidos,
} from "./ReceptorFields";

interface Props {
  open:        boolean;
  cuit:        string;
  collector?:  string;
  initial?:    Partial<Receptor>;
  onClose:     () => void;
  onSaved:     (r: Receptor) => void;
}

export default function ReceptorEditDialog({ open, cuit, collector, initial, onClose, onSaved }: Props) {
  const [form, setForm] = useState<ReceptorFormValue>(receptorFormFrom(initial));
  const [busy, setBusy] = useState(false);
  const [err,  setErr]  = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setForm(receptorFormFrom(initial));
    setErr(null);
  }, [open, initial]);

  const emailsInvalidos = receptorEmailsInvalidos(form);

  async function onSave() {
    setBusy(true); setErr(null);
    try {
      onSaved(await saveReceptor(cuit, receptorPayload(form)));
      onClose();
    } catch (e: any) {
      setErr(e.message ?? "save failed");
    } finally { setBusy(false); }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Editar receptor
        <Typography variant="body2" color="text.secondary">
          CUIT {cuit}{collector ? ` — ${collector}` : ""}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <ReceptorFields
            cuit={cuit} value={form} onChange={setForm} disabled={busy} resetKey={open}
          />
          {err && <Alert severity="error">{err}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancelar</Button>
        <Button onClick={onSave} variant="contained" disabled={busy || emailsInvalidos.length > 0}>
          {busy ? "Guardando…" : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
